import { Command } from 'common/Prose/Commands'
import { Node as ProseNode } from 'prosemirror-model'
import { toggleStateStore } from '../nodeViews/ToggleList/store'

/**
 * Expands a collapsed toggle list and vice versa.
 */
export const toggleToggleList: Command = ({ schema, selection: { $from, $to, empty } }) => {
  if (!empty && $from.node() !== $to.node()) return false

  let toggleNode: ProseNode | undefined
  for (let depth = $from.depth; depth >= 0; --depth) {
    const node = $from.node(depth)
    if (node.type === schema.nodes.toggle_list) {
      toggleNode = node
      break
    }
  }

  if (toggleNode == null) return false

  const { blockId } = toggleNode.attrs
  toggleStateStore.getState(blockId).then((expanded) => {
    toggleStateStore.setState(blockId, !expanded)
  })
  return true
}
